import { PRODUCTS_SERVICE } from "@/services/products.service.js";

const state = {putProductNewBannerOutput: false, postProductReviewsOutput: false, putProductReviewsOutput: false, getProductsReviewsOutput: {}, approveProductReviewByIdOutput: false, postProductOutput: false, getProductsOutput: {}, putProductOutput: false, deleteProductByIdOutput: false, getProductByIdOutput: {}, addPromotionBannerOutput: {}, removePromotionBannerOutput: {}, getProductBySlugOutput: {}, getProductsRelatedOutput: {}, reproveProductReviewByIdOutput: false};

const actions = {
    //Service to add product to promotion banner
    putProductNewBanner({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductNewBannerRequest');

        PRODUCTS_SERVICE.putProductNewBanner(queryParams)
            .then(
                output => {
                    commit('putProductNewBannerSuccess', output);
                },
                error => {
                    commit('putProductNewBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to add reviews
    postProductReviews({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postProductReviewsRequest');

        PRODUCTS_SERVICE.postProductReviews(input)
            .then(
                output => {
                    commit('postProductReviewsSuccess', output);
                },
                error => {
                    commit('postProductReviewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update Reviews
    putProductReviews({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductReviewsRequest');

        PRODUCTS_SERVICE.putProductReviews(input)
            .then(
                output => {
                    commit('putProductReviewsSuccess', output);
                },
                error => {
                    commit('putProductReviewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //
    getProductsReviews({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsReviewsRequest');

        PRODUCTS_SERVICE.getProductsReviews(queryParams)
            .then(
                output => {
                    commit('getProductsReviewsSuccess', output);
                },
                error => {
                    commit('getProductsReviewsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to approve reviews
    approveProductReviewsById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('approveProductReviewByIdRequest');

        PRODUCTS_SERVICE.approveProductReviewsById(id)
            .then(
                output => {
                    commit('approveProductReviewByIdSuccess', output);
                },
                error => {
                    commit('approveProductReviewByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to reprove/remove reviews
    reproveProductReviewsById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('reproveProductReviewByIdRequest');

        PRODUCTS_SERVICE.reproveProductReviewsById(id)
            .then(
                output => {
                    commit('reproveProductReviewByIdSuccess', output);
                },
                error => {
                    commit('reproveProductReviewByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create products
    postProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postProductRequest');

        PRODUCTS_SERVICE.postProduct(input)
            .then(
                output => {
                    commit('postProductSuccess', output);
                },
                error => {
                    commit('postProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get products
    getProducts({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsRequest');

        PRODUCTS_SERVICE.getProducts(queryParams)
            .then(
                output => {
                    commit('getProductsSuccess', output);
                },
                error => {
                    commit('getProductsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update Products
    putProduct({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putProductRequest');

        PRODUCTS_SERVICE.putProduct(input)
            .then(
                output => {
                    commit('putProductSuccess', output);
                },
                error => {
                    commit('putProductFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove Products
    deleteProductById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteProductByIdRequest');

        PRODUCTS_SERVICE.deleteProductById(id)
            .then(
                output => {
                    commit('deleteProductByIdSuccess', output);
                },
                error => {
                    commit('deleteProductByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get product details
    getProductById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductByIdRequest');

        PRODUCTS_SERVICE.getProductById(id)
            .then(
                output => {
                    commit('getProductByIdSuccess', output);
                },
                error => {
                    commit('getProductByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to add product to promotion banner
    addPromotionBanner({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('addPromotionBannerRequest');

        PRODUCTS_SERVICE.addPromotionBanner(id)
            .then(
                output => {
                    commit('addPromotionBannerSuccess', output);
                },
                error => {
                    commit('addPromotionBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove current product banner
    removeCurrentProductBanner({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('removeCurrentProductBannerRequest');

        PRODUCTS_SERVICE.removeCurrentProductBanner()
            .then(
                output => {
                    commit('removeCurrentProductBannerSuccess', output);
                },
                error => {
                    commit('removeCurrentProductBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get product details
    getProductBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductBySlugRequest');

        PRODUCTS_SERVICE.getProductBySlug(queryParams)
            .then(
                output => {
                    commit('getProductBySlugSuccess', output);
                },
                error => {
                    commit('getProductBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //
    getProductsRelated({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getProductsRelatedRequest');

        PRODUCTS_SERVICE.getProductsRelated(queryParams)
            .then(
                output => {
                    commit('getProductsRelatedSuccess', output);
                },
                error => {
                    commit('getProductsRelatedFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //putProductNewBanner
    putProductNewBannerRequest(state) {
        state.putProductNewBannerOutput = null;
    },
    putProductNewBannerSuccess(state, output) {
        state.putProductNewBannerOutput = true;
    },
    putProductNewBannerFailure(state) {
        state.putProductNewBannerOutput = false;
    },

    //postProductReviews
    postProductReviewsRequest(state) {
        state.postProductReviewsOutput = null;
    },
    postProductReviewsSuccess(state, output) {
        state.postProductReviewsOutput = true;
    },
    postProductReviewsFailure(state) {
        state.postProductReviewsOutput = false;
    },

    //putProductReviews
    putProductReviewsRequest(state) {
        state.putProductReviewsOutput = null;
    },
    putProductReviewsSuccess(state, output) {
        state.putProductReviewsOutput = true;
    },
    putProductReviewsFailure(state) {
        state.putProductReviewsOutput = false;
    },

    //getProductsReviews
    getProductsReviewsRequest(state) {
    },
    getProductsReviewsSuccess(state, output) {
        state.getProductsReviewsOutput = output;
    },
    getProductsReviewsFailure(state) {
        state.getProductsReviewsOutput = false;
    },

    //ApproveProductReviewsById
    approveProductReviewByIdRequest(state) {
        state.approveProductReviewByIdOutput = null;
    },
    approveProductReviewByIdSuccess(state, output) {
        state.approveProductReviewByIdOutput = true;
    },
    approveProductReviewByIdFailure(state) {
        state.approveProductReviewByIdOutput = false;
    },

    //ReproveProductReviewsById
    reproveProductReviewByIdRequest(state) {
        state.reproveProductReviewByIdOutput = null;
    },
    reproveProductReviewByIdSuccess(state, output) {
        state.reproveProductReviewByIdOutput = true;
    },
    reproveProductReviewByIdFailure(state) {
        state.reproveProductReviewByIdOutput = false;
    },

    //postProduct
    postProductRequest(state) {
        state.postProductOutput = null;
    },
    postProductSuccess(state, output) {
        state.postProductOutput = true;
    },
    postProductFailure(state) {
        state.postProductOutput = false;
    },

    //getProducts
    getProductsRequest(state) {
    },
    getProductsSuccess(state, output) {
        state.getProductsOutput = output;
    },
    getProductsFailure(state) {
        state.getProductsOutput = false;
    },

    //putProduct
    putProductRequest(state) {
        state.putProductOutput = null;
    },
    putProductSuccess(state, output) {
        state.putProductOutput = true;
    },
    putProductFailure(state) {
        state.putProductOutput = false;
    },

    //deleteProductById
    deleteProductByIdRequest(state) {
        state.deleteProductByIdOutput = null;
    },
    deleteProductByIdSuccess(state, output) {
        state.deleteProductByIdOutput = true;
    },
    deleteProductByIdFailure(state) {
        state.deleteProductByIdOutput = false;
    },

    //getProductById
    getProductByIdRequest(state) {
    },
    getProductByIdSuccess(state, output) {
        state.getProductByIdOutput = output;
    },
    getProductByIdFailure(state) {
        state.getProductByIdOutput = false;
    },

    //add product to promotion banner
    addPromotionBannerRequest(state) {
        state.addPromotionBannerOutput = null;
    },
    addPromotionBannerSuccess(state) {
        state.addPromotionBannerOutput = true;
    },
    addPromotionBannerFailure(state) {
        state.addPromotionBannerOutput = false;
    },
    
    //remove current product banner
    removeCurrentProductBannerRequest(state) {
        state.removePromotionBannerOutput = null;
    },
    removeCurrentProductBannerSuccess(state) {
        state.removePromotionBannerOutput = true;
    },
    removeCurrentProductBannerFailure(state) {
        state.removePromotionBannerOutput = false;
    },

    //getProductBySlug
    getProductBySlugRequest(state) {
    },
    getProductBySlugSuccess(state, output) {
        state.getProductBySlugOutput = output;
    },
    getProductBySlugFailure(state) {
        state.getProductBySlugOutput = false;
    },

    //getProductsRelated
    getProductsRelatedRequest(state) {
    },
    getProductsRelatedSuccess(state, output) {
        state.getProductsRelatedOutput = output;
    },
    getProductsRelatedFailure(state) {
        state.getProductsRelatedOutput = false;
    },
};

export const products = {
    namespaced: true,
    state,
    actions,
    mutations
};